var exports = {
  "qI": "MiniStatusGrid___xoUNG",
  "vi": "MiniStatusWrapper__t96GwR",
  "c3": "MiniStatus__eXKwQ4",
  "ss": "MiniStatusFirst__pV-y3n",
  "Gm": "MiniStatusInteractive__LZfJhK",
  "Ud": "MiniStatusButton__UVquRF",
  "he": "MiniStatusExpanded__TpW5jI",
  "fN": "MiniStatusGridExpanded__lZZX5Z",
  "BW": "ExpandedChecks__uozHbK",
  "Jp": "MiniStatusRefresh__E5U0sl",
  "g_": "MiniStatusLabelRow__AvvLNy",
  "gO": "MiniStatusLabel__3mlSlf",
  "H3": "MiniStatusLabelText__7wOALt",
  "D4": "MiniStatusRatio__POVRp4",
  "PM": "MiniStatusProgress__Dn0Fnh",
  "x2": "MiniStatusUnavailableProgress__oOLji4",
  "XB": "MiniStatusLoadingIcon__4Gfhse",
};

module.exports = exports;
